<!-- 				-->
<!-- Confirm Dialog -->
<!-- 				-->
<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!-- 		 	 -->
<!-- LOCK TO TOP -->
<!-- 			 -->
<div class="lock-to-top-off" style="background-color: #ffffff">
	<!-- 		 	     -->
	<!-- Person Selector -->
	<!-- 			 	 -->
	<div>
		<caass-personselector
			[AudienceID]="1"
			[CanSwitchAudience]="false"
			[ShowAllSchools]="false"
			[MultiSelect]="true"
			[buttonMultiSelectProcessCaption]="'Select'"
		></caass-personselector>
	</div>

	<!-- 					 	  -->
	<!-- MealSubsidyType Selector -->
	<!-- 				 		  -->
	<div class="selector-item">
		<div>
			<label>Meal Subsidy Type</label>
		</div>
		<div style="margin-left: 10px">
			<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
			<select
				class="form-control"
				name="MealSubsidyTypeSelector"
				style="font-size: smaller"
				[(ngModel)]="SelectedMealSubsidyType"
				(ngModelChange)="onMealSubsidyTypeChange($event)"
			>
				<option *ngFor="let r of lstMealSubsidyType" [ngValue]="r">
					{{ r.MealSubsidyTypeDesc }}
				</option>
			</select>
		</div>
	</div>

	<!-- 		 -->
	<!-- Buttons -->
	<!-- 		 -->
	<div class="button-body-unassigned">
		<button class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onAssign()">Assign</button>
		<img class="info-img" (click)="onToggleInfo1()" src="assets/images/info-24.png" />
		<label class="button-body-assigned-text" style="margin-left: 25px">Unassigned Students</label>
	</div>

	<div style="padding: 20px; padding-top: 0px; background-color: #ebebeb" [style.display]="isShowInfo1 == true ? 'block' : 'none'">
		<label>&#9900; Select students from the student selector to be added to this list.</label><br />
		<label>&#9900; Students that are assigned will be filtered out from this list.</label><br />
		<label>&#9900; Total Unassigned: {{ lstUnAssigned.length }}</label
		><br />
		<label>&#9900; Use ctl to add a column to the sort selection</label><br />
	</div>
</div>

<!-- 					  -->
<!-- Display UnAssigned   -->
<!-- 					  -->
<div class="table-main-body">
	<!-- Note: resizableColumns breaks the multiline ability -->
	<p-table
		#UnAssigneddt
		[value]="lstUnAssigned"
		[paginator]="true"
		[(rows)]="pagerowsU"
		[(first)]="pagefirstU"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="multiple"
		[(selection)]="lstUnAssignedChecked"
		[rowHover]="true"
		dataKey="PersonID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[10, 25, 50, 100]"
	>
		<ng-template pTemplate="header">
			<!-- 			  -->
			<!-- Sort Section -->
			<!-- 			  -->
			<tr>
				<th style="width: 3rem">
					<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
				</th>
				<th pSortableColumn="FirstName">First Name<p-sortIcon field="FirstName"></p-sortIcon></th>
				<th pSortableColumn="LastName">Last Name<p-sortIcon field="LastName"></p-sortIcon></th>
				<th pSortableColumn="StudentID">StudentID<p-sortIcon field="StudentID"></p-sortIcon></th>
				<th pSortableColumn="Homeroom">Homeroom<p-sortIcon field="Homeroom"></p-sortIcon></th>
			</tr>
		</ng-template>

		<ng-template pTemplate="body" let-rUnAssignedItem>
			<tr [pSelectableRow]="rUnAssignedItem">
				<td>
					<div>
						<p-tableCheckbox [pSelectableRow]="rUnAssignedItem" [value]="rUnAssignedItem"></p-tableCheckbox>
					</div>
				</td>

				<td>
					<div>
						{{ rUnAssignedItem.FirstName }}
					</div>
				</td>

				<td>
					<div>
						{{ rUnAssignedItem.LastName }}
					</div>
				</td>

				<td>
					<div>
						{{ rUnAssignedItem.StudentID }}
					</div>
				</td>

				<td>
					<div>
						{{ rUnAssignedItem.Homeroom }}
					</div>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!-- 						       -->
<!-- Display When No Cards Printed -->
<!-- 						       -->
<div style="padding: 20px" [style.display]="lstUnAssigned.length < 1 && isBusy == false ? 'block' : 'none'">
	<label>No Students Selected...</label>
</div>

<!-- 		 -->
<!-- Buttons -->
<!-- 		 -->
<div class="button-body-unassigned">
	<button class="btn btn-primary" style="margin-left: 0px" (click)="onUnassign()">Unassign</button>
	<img class="info-img" (click)="onToggleInfo2()" src="assets/images/info-24.png" />
	<label class="button-body-assigned-text" style="margin-left: 25px">Assigned Students</label>
	<label class="button-body-assigned-text" style="margin-left: 25px; color: blue">{{ MealSubsidyTypeDesc }} ({{ MealSubsidyPct | number : "1.0-2" }}%)</label>
</div>

<div style="padding: 20px; padding-top: 0px; background-color: #ebebeb" [style.display]="isShowInfo2 == true ? 'block' : 'none'">
	<label>&#9900; Total Assigned: {{ lstAssigned.length }}</label
	><br />
	<label>&#9900; Use ctl to add a column to the sort selection</label><br />
</div>

<!-- 					  -->
<!-- Display Assigned 	  -->
<!-- 					  -->
<div class="table-main-body">
	<!-- Note: resizableColumns breaks the multiline ability -->
	<p-table
		#Assigneddt
		[value]="lstAssigned"
		[paginator]="true"
		[(rows)]="pagerowsA"
		[(first)]="pagefirstA"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="multiple"
		[(selection)]="lstAssignedChecked"
		[rowHover]="true"
		dataKey="PersonID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[10, 25, 50, 100]"
	>
		<ng-template pTemplate="header">
			<!-- 			  -->
			<!-- Sort Section -->
			<!-- 			  -->
			<tr>
				<th style="width: 3rem">
					<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
				</th>
				<th pSortableColumn="FirstName">First Name<p-sortIcon field="FirstName"></p-sortIcon></th>
				<th pSortableColumn="LastName">Last Name<p-sortIcon field="LastName"></p-sortIcon></th>
				<th pSortableColumn="StudentID">StudentID<p-sortIcon field="StudentID"></p-sortIcon></th>
				<th pSortableColumn="Homeroom">Homeroom<p-sortIcon field="Homeroom"></p-sortIcon></th>
			</tr>
		</ng-template>

		<ng-template pTemplate="body" let-rAssignedItem>
			<tr [pSelectableRow]="rAssignedItem">
				<td>
					<div>
						<p-tableCheckbox [pSelectableRow]="rAssignedItem" [value]="rAssignedItem"></p-tableCheckbox>
					</div>
				</td>

				<td>
					<div>
						{{ rAssignedItem.FirstName }}
					</div>
				</td>

				<td>
					<div>
						{{ rAssignedItem.LastName }}
					</div>
				</td>

				<td>
					<div>
						{{ rAssignedItem.StudentID }}
					</div>
				</td>

				<td>
					<div>
						{{ rAssignedItem.Homeroom }}
					</div>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!-- 						       -->
<!-- Display When No Cards Printed -->
<!-- 						       -->
<div style="padding: 20px" [style.display]="lstAssigned.length < 1 && isBusy == false ? 'block' : 'none'">
	<label>No Students Assigned...</label>
</div>
